import gql from 'graphql-tag'

import { Article } from './fragments'

export const getArticleSlugs = gql`
  query getArticleSlugs {
    slugs: articleUrls
  }
`

export const getArticles = gql`
  query getArticles(
    $page: Int!
    $pageSize: Int!
    $category: String
    $subcategory: String
    $keyword: String
    $tags: [String]
  ) {
    results: articles(
      page: $page
      pageSize: $pageSize
      category: $category
      subcategory: $subcategory
      keyword: $keyword
      tags: $tags
    ) {
      meta {
        page
        pageTotal
        count
      }
      articles {
        ...Article
      }
    }
  }
  ${Article}
`

export const getArticleCategories = gql`
  query getArticleCategories {
    categories: articleCategories {
      id
      name
    }
  }
`

export const getArticle = gql`
  query getArticle($titleSlug: String!) {
    article: articleByTitleSlug(titleSlug: $titleSlug) {
      ...Article
    }
  }
  ${Article}
`

export const getFeaturedArticles = gql`
  query getFeaturedArticles($category: String!) {
    articles: featuredArticles(category: $category) {
      ...Article
    }
  }
  ${Article}
`

export const getPopularArticles = gql`
  query getPopularArticles($limit: Int) {
    articles: popularArticles(limit: $limit) {
      id
      title
      titleSlug
    }
  }
`

export const getRelatedArticles = gql`
  query getRelatedArticles(
    $limit: Int
    $category: String
    $subcategory: String
    $tags: [String]
  ) {
    articles: relatedArticles(
      limit: $limit
      category: $category
      subcategory: $subcategory
      tags: $tags
    ) {
      ...Article
    }
  }
  ${Article}
`
